/** The Issues feature route (SWOOP-255). A Maintenance-module surface gated on `issues:list`. */
export const ISSUES_PATH = '/issues';

/** Reading issues. */
export const ISSUES_LIST_PERMISSION = 'issues:list';

/** Reporting, changing status and commenting on issues. */
export const ISSUES_MANAGE_PERMISSION = 'issues:manage';
